import { connect } from 'react-redux';
import SnackAlert from '../../../components/Layout/SnackAlert.tsx';
import { RootState } from '@/core/types/state';
import { snack } from '@/core/selectors';
import { setSnackAlert } from '@/core/slices/alert.ts';

const ConnectedSnackAlert = connect(
  (state: RootState) => ({
    snack: snack(state),
  }),
  {
    setSnackAlert,
  },
)(SnackAlert);

export default ConnectedSnackAlert;
